import {ErrorHandler, Inject, Injectable, Injector, Type} from '@angular/core';
import {CORE_CONFIGURATION} from '../configuration';
import { datadogRum } from '@datadog/browser-rum';
import { environment } from '../../../environments/environment';
import { SessionState, SessionStateModel } from '../session';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { BaseCustomErrorResponse } from '../api/custom-error-response.type';
import { HttpErrorResponse } from '@angular/common/http';
import * as StackTraceParser from 'error-stack-parser';
import { AuthGuard } from '../auth';
import { datadogLogs } from '@datadog/browser-logs';

@Injectable({
  providedIn: 'root',
  deps: [
    CORE_CONFIGURATION,
    ErrorHandler
  ]
})
export class LoggerService {
  constructor(
    @Inject(CORE_CONFIGURATION) public config,
    private injector: Injector,
    private errorHandler: ErrorHandler,
  ) {
  }

  group(name: string, ...logger: any[]) {
    if (this.config.enableTracing) {
      console.group(name);
      logger.forEach(log => console.log(log));
      console.groupEnd();
    }
  }

  info(value: any, ...rest: any[]): void {
    if (this.config.enableTracing) {
      console.log(value, ...rest);
    }
  }

  warn(value: any, ...rest: any[]): void {
    if (this.config.enableTracing) {
      console.warn(value, ...rest);
    }
  }

  error(error: Error): void {
    if (this.config.enableTracing) {
      this.errorHandler.handleError(error);
    }
  }

  datadog(error: Error, data?: any): void {
    if (location.hostname !== 'localhost' && location.hostname !== '127.0.0.1') {
      datadogRum.addError(error, data);
      datadogLogs.logger.error(error.message, {...data, error});
    }
  }

}
